import React, { useState, useContext, useEffect } from "react";

import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import GenericModal from "src/GenericModal";
import warnIcon from "../../assets/images/warn-circle-red.svg";

import loaderData from "../../assets/loader.json";
import BackArrow from "../../atoms/backArrow/backArrow";
import AmountInput from "../../atoms/amountInput/amountInput";
import LoaderLight from "../../atoms/loaderLight/loaderLight";

import { setCookie, formatAmountinINR } from "../../utils/utils";
import { makeAPICall } from "../../services/apiService";

import "./styles.scss";

const InitiateLoan = () => {
  const history = useHistory();
  const [amountText, setAmountText] = useState("");
  const [showValidationSheet, setShowValidationSheet] = useState(false);
  const [loader, setLoader] = useState(false);
  const [banksList, setBanksList] = useState([]);
  const [bank, setBank] = useState("");
  const [netAmountText, setNetAmountText] = useState("");
  const [selectedBank, setSelectedBank] = useState({});
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [disableAmountText, setDisableAmountText] = useState(true);
  const [disableNetAmountText, setNetDisableAmountText] = useState(true);
  const [hypothecationCheck, setHypothecationCheck] = useState(false);
  const [showNetAmountErrorMsg, setShowNetAmountErrorMsg] = useState(false);

  const handleChange = (event) => {
    setBank(event.target.value);
    let selectedBank = banksList.find(
      (bank) => bank.afm_provider_id === event.target.value
    );
    setSelectedBank(selectedBank);
    setDisableAmountText(false);
    setNetDisableAmountText(false);
  };

  const onChangeAmount = (value) => {
    if (value) {
      let checkminValue = selectedBank.minimum_amount;
      if (parseInt(value) < parseInt(checkminValue)) {
        setShowErrorMsg(true);
        setAmountText(value);
      } else if (value.length <= 7) {
        setShowErrorMsg(false);
        setAmountText(value);
      } else {
        setShowErrorMsg(false);
      }
    } else {
      setAmountText("");
      setShowErrorMsg(false);
    }
  };

  const onChangeNetAmount = (value) => {
    if (value) {
      let checkminValue = amountText;
      if (parseInt(value) > parseInt(checkminValue)) {
        setShowNetAmountErrorMsg(true);
        setNetAmountText(value);
      } else if (value.length <= 7) {
        setShowNetAmountErrorMsg(false);
        setNetAmountText(value);
      } else {
        setShowNetAmountErrorMsg(false);
      }
    } else {
      setNetAmountText("");
      setShowNetAmountErrorMsg(false);
    }
  };

  useEffect(() => {
    getOfflineBanksList();
  }, []);

  const getOfflineBanksList = () => {
    let config = {
      method: "get",
      url: `/api/loan/getOfflineBanks`,
    };
    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
          setBanksList(resp.data.data.data.data);
        }
      })
      .catch((e) => {
        console.log("Fail ", e);
      });
  };

  const submitOfflinePayment = () => {
    setLoader(true);

    let loanOrdersDetails = localStorage.getItem("loanOrderDetails");

    let loanDetailsParsed = JSON.parse(loanOrdersDetails);

    let config = {
      method: "post",
      url: `api/loan/initiateOfflinePayment`,
      data: {
        max_eligible_amount: amountText,
        order_id: loanDetailsParsed.order_id,
        provider_id: bank,
        net_disbursement_amount: netAmountText,
        // no_hypothecation: hypothecationCheck
      },
    };

    makeAPICall(config)
      .then((resp) => {
        console.log("submitOfflinePayment", resp)
        if (resp) {
          history.push("/offline-transaction-status");
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  let loanOrdersDetails = localStorage.getItem("loanOrderDetails");

  let loanDetailsParsed = JSON.parse(loanOrdersDetails);

  //console.log("selectedBank", selectedBank);

  return (
    <div className="loan-container">
      <div className="header">
        <Link to="/offline-finance-search">
          <BackArrow />
        </Link>
      </div>
      <div className="inner-container">
        <div className="orderlist-container">
          <div>
            <div className="order-number">{loanDetailsParsed.name}</div>
            <div className="user-name">{loanDetailsParsed.order_id}</div>
          </div>
        </div>
        <div className="label">Select bank</div>
        <Select
          value={bank}
          onChange={handleChange}
          inputProps={{ "aria-label": "Without label" }}
          placeholder="Select Bank"
          name="bank"
          style={{
            width: "100%",
            backgroundColor: "#fff",
            borderRadius: 0,
            border: "none",
          }}
        >
          {banksList.map((bank) => (
            <MenuItem value={bank.afm_provider_id}>
              {bank.display_name}
            </MenuItem>
          ))}
        </Select>
        <div className="label">Maximum eligible loan amount</div>
        <AmountInput
          id="amount"
          name="amount"
          inputValue={amountText}
          disableAmountText={disableAmountText}
          onChange={(value) => onChangeAmount(value)}
        />
        {showErrorMsg && (
          <div className="error-msg-container">
            <span className="error-msg-text">
              Minimum amount should be{" "}
              {formatAmountinINR(selectedBank.minimum_amount)}
            </span>
          </div>
        )}
        <div className="label">Net disbursement amount</div>
        <AmountInput
          id="net-amount"
          name="net-amount"
          inputValue={netAmountText}
          disableAmountText={disableNetAmountText}
          onChange={(value) => onChangeNetAmount(value)}
        />
        {showNetAmountErrorMsg && (
          <div className="error-msg-container">
            <span className="error-msg-text">
            Maximum Net Disbursement amount should be{" "}
              {formatAmountinINR(amountText)}
            </span>
          </div>
        )}
        {/* <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={hypothecationCheck}
                onChange={(event)=> setHypothecationCheck(event.target.checked)}
                color="default"
              />
            }
            label="This is a No Hypothecation order"
          />
        </FormGroup> */}
      </div>
      <button
        className={
          bank && amountText && !showErrorMsg && netAmountText && !showNetAmountErrorMsg 
            ? "initiate_loan_button"
            : "initiate_loan_button-disabled"
        }
        type="submit"
        onClick={() => setShowValidationSheet(true)}
      >
        Initiate loan
      </button>
      {showValidationSheet && (
        <GenericModal
          onClose={() => !loader && setShowValidationSheet(false)}
          showClose={false}
        >
          <div className={`tr-validation-container ${"trCont"}`}>
            <div className="heading-container">
              <p className="error-heading">Confirm loan details</p>
              <img
                src={warnIcon}
                alt="warning"
                className="warn-icon"
                style={{ marginTop: 25 }}
              />
            </div>
            <div className="error-subheading">
              Please confirm the loan details mentioned below for the customer
            </div>
            <div style={{ background: "#F1F3F5", padding: 16, marginTop: 24 }}>
              <div className="popup-list">
                <div className="popup-title">Bank</div>
                <div className="popup-desc">{selectedBank?.display_name}</div>
              </div>
              <div className="popup-list">
                <div className="popup-title">Max eligible loan amount</div>
                <div className="popup-desc">
                  {formatAmountinINR(amountText)}
                </div>
              </div>
            </div>
            <div className="two-btns">
              <button
                className="cancel"
                onClick={() => !loader && setShowValidationSheet(false)}
              >
                Edit
              </button>
              {loader ? (
                <button className={`loader-button`}>
                  <div className="loader-container-np">
                    <LoaderLight
                      loaderData={loaderData}
                      loaderStyle="loader-light-np"
                    />
                  </div>{" "}
                </button>
              ) : (
                <button
                  className="confirm"
                  onClick={() => submitOfflinePayment()}
                >
                  Confirm
                </button>
              )}
            </div>
          </div>
        </GenericModal>
      )}
    </div>
  );
};

export default InitiateLoan;
